<template>
  <div>
    <div
      :style="{
        padding: '24px',
        margin: '24px 16px 24px 16px',
        background: '#fff',
        minHeight: '100px',
      }"
    >
      <a-form-model
        ref="ruleForm"
        layout="inline"
        :model="formInline"
        @submit="handleSubmit"
        @submit.native.prevent
      >
        <a-row>
          <a-col :span="6">
            <a-form-model-item label="订单编号" prop="user">
              <a-input v-model="formInline.orderNo" placeholder="请输入">
              </a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item label="邮寄单号" prop="trackingNumber">
              <a-input v-model="formInline.trackingNumber" placeholder="请输入"> </a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item label="订单状态" prop="orderStatus">
              <a-select
                v-model="formInline.orderStatus"
                placeholder="请选择"
                allowClear
                style="width: 180px;"
              >
                <a-select-option :value="0">待领取/待发货</a-select-option>
                <a-select-option :value="2">已领取</a-select-option>
                <a-select-option :value="3">已发货</a-select-option>
                <a-select-option :value="1">已取消</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item label="是否已完成" prop="isReceive">
              <a-select
                v-model="formInline.isReceive"
                placeholder="请选择"
                allowClear
                style="width: 180px;"
              >
                <a-select-option :value="1">是</a-select-option>
                <a-select-option :value="0">否</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row style="margin-top: 16px;">
          <a-col :span="12">
            <a-form-model-item label="下单时间" prop="store">
              <a-range-picker format="YYYY-MM-DD HH:mm:ss" @change="onChange" v-model="formInline.createTime"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item>
              <a-button type="primary" html-type="submit" @click="query">
                查询
              </a-button>
              <a-button style="margin-left: 10px" @click="resetForm">
                重置
              </a-button>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </div>

    <a-layout-content style="margin: 0 16px">
      <div :style="{ padding: '24px', background: '#fff', minHeight: '360px' }">
        <exchangeOrderHomeContentTwo
          ref="aaa"
          :formInline="formInline"
        ></exchangeOrderHomeContentTwo>
      </div>
    </a-layout-content>
    <!-- <memberManagementContent></memberManagementContent> -->
  </div>
</template>

<script>
import exchangeOrderHomeContentTwo from "./exchangeOrderHomeContentTwo.vue";
export default {
  components: {
    exchangeOrderHomeContentTwo,
  },
  data() {
    return {
      formInline: {
        orderNo: "",
        trackingNumber: "",
        orderStatus: undefined,
        isReceive: undefined,
        limit: 10,
        page: 1,
        startTime: "",
        endTime: "",
      },
    };
  },
  methods: {
    resetForm() {
      if(this.$refs.aaa.isShow){
        this.$refs.aaa.getStoreExchangeList();
      };
      this.formInline = {
        orderNo: "",
        trackingNumber: "",
        orderStatus: undefined,
        isReceive: undefined,
        limit: 10,
        page: 1,
        startTime: "",
        endTime: "",
        createTime: "",
      };
    },
    onChange(date, dateString) {
      console.log(date, dateString);
      this.formInline.startTime = dateString[0];
      this.formInline.endTime = dateString[1];
    },
    query() {
      this.$refs.aaa.seach();
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/orderManagement/exchangeOrderHomeTwo.vue